import {Dimensions, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {black, white} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';
const width = Dimensions.get('window').width;
const width360 = width <= 390;

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    height: 35,
    paddingVertical: indent * 0.2,
    paddingHorizontal: indent * 0.8,
    borderRadius: indent * 0.4,
    borderColor: alto,
    backgroundColor: white,
  },
  buttonSort: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 35,
    flex: 1,
    flexShrink: 1,
    minWidth: 0,
    backgroundColor: white,
    borderWidth: 1,
    borderColor: alto,
    paddingVertical: indent * 0.2,
    paddingHorizontal: indent * 0.8,
    borderRadius: indent * 0.4,
  },

  buttonSortIOS: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    flexShrink: 1,
    minWidth: 0,
    height: 35,
    backgroundColor: white,
    borderWidth: 1,
    borderColor: alto,
    paddingVertical: indent * 0.2,
    paddingHorizontal: indent * 0.8,
    borderRadius: indent * 0.4,
  },

  loading: {
    opacity: 0.5,
  },
  text: {
    marginLeft: indent * 0.4,
    fontSize: 14,
    maxWidth: 150,
  },
  textReport: {
    marginLeft: width360 ? 4 : indent * 0.4,
    fontSize: 12,
    maxWidth: width360 ? 100 : 200,
    color: black,
  },
  icon: {
    fontSize: 14,
    width: 16,
    height: 16,
  },
  dropdownIcon: {
    fontSize: 16,
    paddingVertical: 5,
    color: 'gray',
  },
  iconReport: {
    fontSize: 18,
    width: 18,
    height: 18,
    alignSelf: 'center',
    justifyContent: 'center',
    paddingTop: 8,
  },
  disabled: {
    opacity: 0.5,
    backgroundColor: 'grey',
  },
});
